import Model from "./abstract/Model";
import Depot from "./Depot";
import Accessory from "./Accessory";
import VehicleSegment from "./VehicleSegment";
import Image from "./Image";

export const MatchType = {
  INCLUDED: "INCLUDED",
  EXCLUDED: "EXCLUDED"
};

export default class Vehicle extends Model {
  vehicle_object_type_id;
  vehicle_status_id;
  license_plate;
  vin_number;
  vehicle_model_id;
  vehicle_type_id;
  vehicle_group_id;
  vehicle_segment_id;
  mileage_current;
  tracking_number;
  vehicle_color_id;
  num_of_seats;
  num_of_doors;
  vehicle_transmission_type_id;
  vehicle_fuel_type_id;
  depot_id;
  country_id;
  image_id;
  client_id;
  tank_capacity;
  tank_level_percentage;
  list_price;
  tax_addition_percentage;
  first_admission_date;
  date_mot_expiration;
  available_from;

  constructor(props) {
    super();

    this.initializeAttributes(props, Vehicle.getAttributeMap());
  }

  static getAttributeMap() {
    return {
      depot: Depot,
      segment: VehicleSegment,
      accessories: value => Accessory.list(value),
      available_from: Date,
      at_depot_since: Date,
      images: value => Image.list(value)
    };
  }

  get main_image() {
    if (!this.images || !this.images.length) return;

    const image = this.images.find(image => image.id == this.image_id);
    if (!image) image = this.images[0];

    return image;
  }

  get sort_title() {
    return (
      this.segment?.name +
      (this.at_depot_since ? this.at_depot_since.toISOString() : "") +
      this.brand_name +
      this.type?.name +
      this.license_plate_formatted
    );
  }

  get model_name() {
    return this.model?.name;
  }

  get brand_name() {
    return this.model?.brand?.name;
  }

  get name() {
    const parts = [this.model?.brand?.name, this.model?.name].filter(Boolean);

    // display_name is the backend's own label for a vehicle whose model is not
    // filled in; without it an incomplete record renders "undefined - undefined".
    return parts.length ? parts.join(" - ") : this.display_name ?? "";
  }

  get available_from_is_passed() {
    if (!this.available_from) return true;

    const now = new Date();
    return this.available_from.getTime() < now.getTime();
  }
}
